import PropTypes from "prop-types";
import ButtonGroupDynamic from "../common/ButtonGroupDynamic";
import SurveySourceBadge from "./SurveySourceBadge";
import "./surveyManagement.scss";

const AvailableSurveyCard = ({ row, actionButtons }) => (
  <div className="survey-card">
    <div className="survey-card__header">
      <h6 className="survey-card__title">{row.surveyName}</h6>
      <ButtonGroupDynamic
        items={actionButtons}
        size="small"
        spacing="0px"
        variant="control"
      />
    </div>
    <SurveySourceBadge source={row.source} />
    <dl className="survey-card__meta">
      <div>
        <dt>Survey ID</dt>
        <dd>{row.surveyId}</dd>
      </div>
      <div>
        <dt>Survey URL</dt>
        <dd>{row.surveyUrl}</dd>
      </div>
    </dl>
  </div>
);

AvailableSurveyCard.propTypes = {
  row: PropTypes.object.isRequired,
  actionButtons: PropTypes.array,
};

export default AvailableSurveyCard;
